

import { makeStyles } from 'tss-react/mui';
import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import Grid from 'web-library/stories/atom/Grid/Grid';
import Typography from 'web-library/stories/atom/Typography/Typography';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  headerLabel: {
    fontWeight: 800,
    color: theme.color.text.textHeader,
     ...typographyTheme(theme, 'h4'),
  },
  footerLabel: {
    fontWeight: 800,
    color: theme.color.text.textHeader,
  },
  subFooterLabel: {
    fontWeight: 800,
    color: theme.color.text.textHeader,
     ...typographyTheme(theme, 'h5'),
  },
  bodyLabel: {
    color: theme.color.text.textPrimary,
  },
  headerValue: {
    color: theme.color.text.textHeader,
    fontWeight: 800,
    textAlign: 'right',
  },
  bodyValue: {
    color: theme.color.text.textPrimary,
  },
  footerValue: {
    fontWeight: 800,
     ...typographyTheme(theme, 'h4'),
  },
  subFooterValue: {
    color: theme.color.text.textPrimary,
    fontWeight: 700,
  },
  value: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  eachRow: {
    marginBottom: theme.spacing(1.5),
    '&:nth-last-child(2)': {
      marginBottom: theme.spacing(3),
    },
  },
}));

type Variant = 'header' | 'footer' | 'body' | 'subFooter';

const CustomFeeRow = ({
  variant = 'body',
  label,
  value,
  currencyDenomination = true,
}: {
  variant?: Variant;
  label: string;
  value: string;
  currencyDenomination?: boolean;
}) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const currencyValue = value.charAt(0) === '-' ? `-S$${value.slice(1)}` : `S$${value}`;

  return (
    (<Grid md={12} container direction="row" justify="flex-start" className={classes.eachRow}>
      <Grid xs={12} sm={6} md={3}>
        <Typography
          display="block"
          align="left"
          // @ts-ignore
          className={classes[`${variant}Label`]}
        >
          {label}
        </Typography>
      </Grid>
      <Grid
        container
        xs={12}
        sm={6}
        md={3}
        direction="row"
        justify={isMobile ? 'flex-start' : 'flex-end'}
      >
        <Typography
          display="block"
          id={`span-${label.replace(/\s/, '-')}-value`}
          align="left"
          // @ts-ignore
          className={classes[`${variant}Value`]}
        >
          {currencyDenomination ? currencyValue : value}
        </Typography>
      </Grid>
    </Grid>)
  );
};

export default CustomFeeRow;
